import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchFandomRaw = createAsyncThunk(
  "fandomRawData/fetchFandomRaw",

  async ({ lte, gte, interval }) => {
    const response = await axiosInstance.request({
      url: `fandom/raw`,
      method: `GET`,
      params: {
        lte,
        gte,
        interval,
      },
    });
    return response;
  }
);

const fandomRawDataSlice = createSlice({
  name: "fandomRawData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchFandomRaw.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFandomRaw.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchFandomRaw.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const FandomRawDataReducer = fandomRawDataSlice.reducer;

export default FandomRawDataReducer;

export const fandomRawDataAction = fandomRawDataSlice.actions;
